export const ACTION_LOAD_AGREEMENTS =
  "supportui/AgreementsPage/ACTION_LOAD_AGREEMENTS";
export const ACTION_LOAD_AGREEMENTS_COMPLETE =
  "supportui/AgreementsPage/ACTION_LOAD_AGREEMENTS_COMPLETE";
export const ACTION_DELETE_AGREEMENT =
  "supportui/AgreementsPage/ACTION_DELETE_AGREEMENT";
export const ACTION_AGREEMENT_DELETE_SUCCESS =
  "supportui/AgreementsPage/ACTION_AGREEMENT_DELETE_SUCCESS";
export const ACTION_AGREEMENT_DELETE_FAILED =
  "supportui/AgreementsPage/ACTION_AGREEMENT_DELETE_FAILED";
export const ACTION_CREATE_AGREEMENT_DIALOG_SHOW =
  "supportui/AgreementsPage/ACTION_CREATE_AGREEMENT_DIALOG_SHOW";
export const ACTION_CREATE_AGREEMENT_DIALOG_HIDE =
  "supportui/AgreementsPage/ACTION_CREATE_AGREEMENT_DIALOG_HIDE";
export const ACTION_CREATE_AGREEMENT =
  "supportui/AgreementsPage/ACTION_CREATE_AGREEMENT";
export const ACTION_CREATE_AGREEMENT_SUCCESS =
  "supportui/AgreementsPage/ACTION_CREATE_AGREEMENT_SUCCESS";
export const ACTION_CREATE_AGREEMENT_FAILED =
  "supportui/AgreementsPage/ACTION_CREATE_AGREEMENT_FAILED";
export const ACTION_UPLOAD_AGREEMENTS =
  "supportui/AgreementsPage/ACTION_UPLOAD_AGREEMENTS";
export const ACTION_UPLOAD_AGREEMENTS_SUCCEEDED =
  "supportui/AgreementsPage/ACTION_UPLOAD_AGREEMENTS_SUCCEEDED";
export const ACTION_UPLOAD_AGREEMENTS_FAILED =
  "supportui/AgreementsPage/ACTION_UPLOAD_AGREEMENTS_FAILED";
export const ACTION_UPLOAD_AGREEMENTS_COMPLETE =
  "supportui/AgreementsPage/ACTION_UPLOAD_AGREEMENTS_COMPLETE";
export const ACTION_SAVE_AGREEMENTS =
  "supportui/AgreementsPage/ACTION_SAVE_AGREEMENTS";
export const ACTION_AGREEMENTS_SAVED =
  "supportui/AgreementsPage/ACTION_AGREEMENTS_SAVED";
export const ACTION_DOWNLOAD_AGREEMENTS =
  "supportui/AgreementsPage/ACTION_DOWNLOAD_AGREEMENTS";
export const ACTION_DOWNLOAD_AGREEMENTS_STARTED =
  "supportui/AgreementsPage/ACTION_DOWNLOAD_AGREEMENTS_STARTED";
